<ng-container *transloco="let t">
    <ion-refresher slot="fixed" (ionRefresh)="handleRefresh($event)">
        <ion-refresher-content></ion-refresher-content>
    </ion-refresher>
    <div class="main-content">
        <ng-container *ngIf="order$ | async as order">
            <!-- <us-breadcrumbs
                *ngrxLet="homePageUrl$ as homePageUrl"
                [items]="[
                                { title: t('home'),routerLink: homePageUrl },
                                { title: t('orders_list'), routerLink: RouteUtil.getOrdersRouteUrl() },
                                { title: t('order') + ' ' + order.order_code, routerLink: RouteUtil.getOrderRouteUrl(order.order_id) },
                                { title: t('order_status') }
                            ]"
            >
            </us-breadcrumbs> -->

            <us-order-status [order]="order" [hideReloadButton]="true" />
        </ng-container>
    </div>
    <!--<ion-header>
        <ion-toolbar>
            <ion-buttons slot="start">
                <ion-back-button [defaultHref]="orderDetailUrl$ | async"></ion-back-button>
            </ion-buttons>
            <ion-title> {{ t('order_status') }} </ion-title>
        </ion-toolbar>
    </ion-header>
    <ion-content>
        <ion-refresher slot="fixed" (ionRefresh)="handleRefresh($event)">
            <ion-refresher-content></ion-refresher-content>
        </ion-refresher>
        <pre>{{order$ | async | json}}</pre>
        <div class="main-content">


            <ng-container *ngIf="order$ | async as order">
                <us-order-status [order]="order" [hideReloadButton]="true" />
            </ng-container>
        </div>
    </ion-content>-->
</ng-container>
